import Control from './Control';
import rulerGroupHover from '../../img/ruler_grouphover.png';
import rulerHover from '../../img/ruler_hover.png';
import rulerPressed from '../../img/ruler_pressed.png';
import rulerRest from '../../img/ruler_rest.png';

export default class Ruler extends Control {
  constructor(store, dispatcher) {
    super({
      tooltip: 'Ruler (4)',
      mode: 'Ruler',
      srcRest: rulerRest,
      srcGroup: rulerGroupHover,
      srcHover: rulerHover,
      srcDown: rulerPressed,
    }, store, dispatcher);
  }
}